import React, { useState, useEffect } from 'react'
import InfoBar from 'components/InfoBar'
import ListTable from 'components/ListTable'
import toast from 'react-hot-toast'
import ClientSearch from './ClientSearch'

import { getStats } from 'api/claim'

const ClientTable = ({ id, month, year }) => {
  const [currPage, setCurrPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [searchQ, setSearchQ] = useState(null)

  const [list, setList] = useState([])
  const [totalPages, setTotalPages] = useState()

  useEffect(() => {
    setLoading(true)
    getStats(id, month, year, 'client', currPage, 10, searchQ).then(res => {
      setList(res.data.results)
      setTotalPages(res.data.total_pages)
      setLoading(false)
    }).catch(err => {
      console.log(err.response)
      toast.error('Unable to fetch stats')
    })
  }, [month, year, searchQ])

  const _onNext = (page) => {
    setLoading(true)
    getStats(id, month, year, 'client', page + 1, 10).then(res => {
      setList(res.data.results)
      setTotalPages(res.data.total_pages)
      setLoading(false)
    }).catch(err => {
      console.log(err.response)
      toast.error('Unable to fetch stats')
    })
    setCurrPage(page + 1)
  }

  const _onPrevious = (page) => {
    if (page !== 1) {
      setLoading(true)
      getStats(id, month, year, 'client', page - 1, 10).then(res => {
        setList(res.data.results)
        setTotalPages(res.data.total_pages)
        setLoading(false)
      }).catch(err => {
        console.log(err.response)
        toast.error('Unable to fetch stats')
      })
      setCurrPage(page - 1)
    }
  }

  const hasNext = currPage < totalPages

  const clientColumns = [
    {
      Header: 'Client Name',
      id: 'client_name',
      sortable: true,
      Cell: ({ row }) => (
        <div>{row.original.client_name}</div>
      )
    }, {
      Header: 'YouTube',
      id: 'yt_claims',
      sortable: false,
      Cell: ({ row }) => (
        <div>{row.original.yt_claims}</div>
      )
    }, {
      Header: 'SoundExchange',
      id: 'sx_claims',
      sortable: false,
      Cell: ({ row }) => (
        <div>{row.original.sx_claims}</div>
      )
    }, {
      Header: 'MRI',
      id: 'mri_claims',
      sortable: false,
      Cell: ({ row }) => (
        <div>{row.original.mri_claims}</div>
      )
    }, {
      Header: 'MLC',
      id: 'mlc_claims',
      sortable: false,
      Cell: ({ row }) => (
        <div>{row.original.mlc_claims}</div>
      )
    }, {
      Header: 'CMRRA',
      id: 'cmrra_claims',
      sortable: false,
      Cell: ({ row }) => (
        <div>{row.original.cmrra_claims}</div>
      )
    }, {
      Header: 'Total',
      id: 'claims',
      sortable: false,
      Cell: ({ row }) => (
        <div>{row.original.claims}</div>
      )
    }
  ]

  if (loading) {
    return null
  }

  return (
    <div className='list-table'>
      {searchQ
        ? (<InfoBar
          text={"Showing search result for '" + searchQ + "'"}
          onClose={() => setSearchQ(null)}
          showClose
        />)
        : (<ClientSearch
          searchQ={searchQ}
          setSearchQ={setSearchQ}
        />)
      }
      <ListTable
        columns={clientColumns}
        data={list}
        getNext={_onNext}
        getPrev={_onPrevious}
        currPage={currPage}
        setCurrPage={setCurrPage}
        hasNext={hasNext}
        pages={totalPages}
        showPagination
      />
    </div>
  )
}

export default ClientTable
